import { Box, createStyles, makeStyles, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import InformationIcon from '../../assets/icons/InformationIcon';
import { TranquiTheme } from '../../containers/App/theme';

interface InfoTooltipProps {
  children: any;
  className?: string;
  title: string;
  text: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = (props) => {
  const { children, className, title, text } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const [ open, setOpen ] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <Tooltip
      className={className}
      classes={
        {
          tooltip: classes.newTermTooltip,
          arrow: classes.newTermTooltipArrow,
        }
      }
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      open={open}
      onClick={handleTooltipOpen}
      disableHoverListener={false}
      title={
        (
          <>
            <Box className={classes.newTermToolBox}>
              <InformationIcon outlined />
              <Typography className={classes.newTermToolTitle}>{title}</Typography>
            </Box>
            <Typography className={classes.newTermToolText}>{text}</Typography>
          </>
        )
      }
      arrow
      placement="top-end"
      leaveTouchDelay={10000}
    >
      {children}
    </Tooltip>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  newTermTooltip: {
    color: theme.palette.pearl.main,
    backgroundColor: theme.palette.pearl.main,
    border: `solid 1px ${theme.palette.lavender.main}`,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    maxWidth: 330,
    zIndex: 300,
    boxShadow: theme.shadows[3],
  },
  newTermTooltipArrow: {
    color: theme.palette.lavender.main,
  },
  newTermToolBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(-0.75),
    columnGap: theme.spacing(0.5),
  },
  newTermToolTitle: {
    ...theme.typography.h6,
    color: theme.palette.indigo.main,
    fontWeight: 600,
  },
  newTermToolText: {
    ...theme.typography.body2,
  },

}));

export default InfoTooltip;
